import React from 'react';
import { SvgIconProps } from '@mui/material';

export const NoAlertsIconBig: React.FC<SvgIconProps> = (props) => (
    <svg
        width="86"
        height="92"
        viewBox="0 0 86 92"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_4_330)">
            <path
                d="M68.9869 35.4673V42.678C68.9869 47.496 69.9841 52.2615 71.9153 56.6759L74.9904 63.7038C76.5161 67.1915 73.9605 71.0992 70.1543 71.0992H33.355M41.2734 7.75195C25.9669 7.75195 13.5599 20.1608 13.5599 35.4655V42.6762C13.5599 47.4942 12.5626 52.2597 10.6314 56.6741L7.55635 63.702C6.03059 67.1897 8.5862 71.0974 12.3925 71.0974H20.1588M41.2734 7.75195C52.6921 7.75195 62.4965 14.6568 66.7407 24.5172M41.2734 7.75195V1.71949M83.5042 7.75195L1.71936 89.5386"
                stroke="currentColor"
                strokeWidth="3.43885"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_4_330">
                <rect width="85.2237" height="91.258" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default NoAlertsIconBig;
